import {
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH,
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_CANCEL,
} from "constants/action-types";
import { fetchConnectedBrandsError, fetchConnectedBrandsSuccess } from "actions/buyer-dashboard";
import { add as snackbarAdd } from "actions/snackbars";
import { formatMessage } from "lib/globalize-util";
import siteConfig from "site-config";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { updateEntities } from "redux-query";
import { Brands as BrandsSchema } from "schemas/dashboard";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import me from "models/me";

export const fetchBrandsEpic = (action$, store) =>
    action$
        .ofType(BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH)
        .map((payload) => payload)
        .mergeMap((payload) => {
            if (!me.isSignedIn()) {
                return [];
            }
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/brands?`,
            })
                .map(({ response, status }) => ({
                    filters: response.map((brand) => ({ field: "BRAND_ID", value: brand._id })),
                    originalResponse: response,
                }))
                .takeUntil(action$.ofType(BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_CANCEL))
                .mergeMap(({ filters, originalResponse }) =>
                    ajax({
                        body: { filters },
                        hideBeforeUnloadWarning: true,
                        method: "POST",
                        url: `${siteConfig.goAPI}/v1/pages_search`,
                    })
                        .map(({ response }) => {
                            const transformedResponse = originalResponse.map((brand) => {
                                const brandPage = response.data.find((page) => page.brand_id === brand._id) || {};

                                return {
                                    ...brand,
                                    picture: brandPage.picture,
                                };
                            });
                            const brandRecords = getRecordsFromSchema(BrandsSchema);
                            const brandData = normalizeData(transformedResponse, BrandsSchema, brandRecords);
                            return {
                                entities: brandData.entities,
                                brands: brandData.result,
                            };
                        })
                        .mergeMap(({ brands, entities }) => [
                            updateEntities({
                                brands: (currentBrands) => ({
                                    ...currentBrands,
                                    ...entities.brand,
                                }),
                            }),
                            fetchConnectedBrandsSuccess(brands),
                        ])
                        .catch((error) => {
                            if (!me.isSignedIn()) {
                                return [];
                            }
                            return [
                                fetchConnectedBrandsError(error),
                                snackbarAdd({ message: formatMessage("There was an error fetching your brands") }),
                            ];
                        })
                )
                .catch((error) => {
                    if (!me.isSignedIn()) {
                        return [];
                    }
                    return [
                        fetchConnectedBrandsError(error),
                        snackbarAdd({ message: formatMessage("There was an error fetching your brands") }),
                    ];
                });
        });
